import React from 'react'
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux'

import { setProject } from '../../../obj/pscState'

import Confirm from './Confirm'
import useGncHistory from '../../../hooks/useGncHistory'

const DeleteButton = (props) => {
    const url = props.url
    const extraText = props.extraText
    const isHidden = props.isHidden
    const callback = props.callback || null
    const navigateOverride = props.navigateOverride || null
    
    const dispatch = useDispatch()
    const location = useLocation()
    
    const {
        goBack,
    } = useGncHistory()

    const handleDelete = (event) => {
        if(event)
            event.preventDefault()

        fetch(url, {
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json'
            },
            method: 'DELETE',
        }).then(async response => {
            if( callback ) {
                await callback()
            }
            if( navigateOverride ) {
                navigateOverride()
            } else {
                goBack()
            }
        })
    }

    if(isHidden)
        return null
    
    const body = extraText ?
                 (
                     <div>
                         <p>
                             <div style={{float: 'left', marginRight: '8px'}}><i className="fa fa-info-circle"></i></div>
                             <div>{extraText}</div>
                         </p>
                         
                         <p>Are you sure you want to delete this?</p>
                     </div>
                 )
               : 'Are you sure you want to delete this?'
    
    return (
        <Confirm
            onConfirm={handleDelete}
            bodyContent={body}
            confirmText="Confirm Delete"
            title="Delete">
            <button type="button" className="btn btn-mr btn-warning">Delete</button>
        </Confirm>
    )
}

export default DeleteButton
